import { useGetAccounts } from "hooks/useAccounts";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { actions as notificationActions } from "reducers/notification";

export const useTransferAccounts = (scopeToShow = "") => {
    const { accounts, fetching } = useSelector((state) => state.accounts);
    const [debitAccountOptions, setDebitAccountOptions] = useState([]);
    const [debitAccountMep, setDebitAccountMep] = useState([]);
    const [commissionsAccount, setCommissionsAccount] = useState([]);

    const [creditAccountOptions, setCreditAccountOptions] = useState([]);
    const { formatAccountSelector, dispatch } = useGetAccounts("", "", scopeToShow || "internalTransfers", true);

    const handleDebitOptions = () => {
        const availableAccounts = accounts.filter((account) => account.availableBalance > 0 && account.blocked !== "S");
        setDebitAccountOptions(availableAccounts.map((account) => formatAccountSelector(account)));
    };

    const handleDebitMep = () => {
        const availableAccounts = accounts.filter((account) => account.blocked !== "S");
        setDebitAccountMep(availableAccounts.map((account) => formatAccountSelector(account)));
    };

    const handleComissionComex = () => {
        const availableAccounts = accounts.filter(
            (account) => account.availableBalance > 0 && account.currency === "ARS" && account.blocked !== "S",
        );
        setCommissionsAccount(availableAccounts.map((account) => formatAccountSelector(account)));
    };

    const handleCreditOptions = (currency, selectedId) => {
        const availableAccounts = accounts.filter(
            (account) => account.currency === currency && account.productId !== selectedId && account.blocked !== "S",
        );
        setCreditAccountOptions(availableAccounts.map((account) => formatAccountSelector(account)));
    };

    useEffect(() => {
        if (accounts.length !== 0) {
            handleDebitOptions();
            handleDebitMep();
            handleComissionComex();
        }
        if (accounts.length === 1 && scopeToShow === "internalTransfers") {
            dispatch(notificationActions.showNotification("transfers.no.accounts.error", "error", [scopeToShow]));
        }
    }, [accounts]);

    return {
        debitAccountOptions,
        debitAccountMep,
        commissionsAccount,
        creditAccountOptions,
        handleCreditOptions,
        accounts,
        fetching,
    };
};

export default useTransferAccounts;
